export const GRID_DEFAULT_LOCALE_TEXT = {
 // Root
 noRowsLabel: 'Nėra eilučių',
 noResultsOverlayLabel: 'Rezultatų nerasta.',

 // Density selector toolbar button text
 toolbarDensity: 'Tankis',
 toolbarDensityLabel: 'Tankis',
 toolbarDensityCompact: 'Kompaktiškas',
 toolbarDensityStandard: 'Standartinis',
 toolbarDensityComfortable: 'Patogus',

 // Columns selector toolbar button text
 toolbarColumns: 'Stulpeliai',
 toolbarColumnsLabel: 'Pasirinkti stulpelius',

 // Filters toolbar button text
 toolbarFilters: 'Filtrai',
 toolbarFiltersLabel: 'Rodyti filtrus',
 toolbarFiltersTooltipHide: 'Slėpti filtrus',
 toolbarFiltersTooltipShow: 'Rodyti filtrus',
 //  toolbarFiltersTooltipActive: (count: string | number) =>
 //   count !== 1 ? `${count} aktyvūs filtrai` : `${count} aktyvus filtras`,

 // Quick filter toolbar field
 toolbarQuickFilterPlaceholder: 'Ieškoti...',
 toolbarQuickFilterLabel: 'Ieškoti',
 toolbarQuickFilterDeleteIconLabel: 'Išvalyti',

 // Export selector toolbar button text
 toolbarExport: 'Eksportuoti',
 toolbarExportLabel: 'Eksportuoti',
 toolbarExportCSV: 'Atsisiųsti kaip CSV',
 toolbarExportPrint: 'Spausdinti',
 toolbarExportExcel: 'Atsisiųsti kaip Excel',

 // Columns management text
 columnsManagementSearchTitle: 'Paieška',
 columnsManagementNoColumns: 'Nėra stulpelių',
 columnsManagementShowHideAllText: 'Rodyti/Slėpti visus',
 columnsManagementReset: 'Atstatyti',

 // Filter panel text
 filterPanelAddFilter: 'Pridėti filtrą',
 filterPanelRemoveAll: 'Pašalinti visus',
 filterPanelDeleteIconLabel: 'Ištrinti',
 filterPanelLogicOperator: 'Loginis operatorius',
 filterPanelOperator: 'Operatorius',
 filterPanelOperatorAnd: 'Ir',
 filterPanelOperatorOr: 'Arba',
 filterPanelColumns: 'Stulpeliai',
 filterPanelInputLabel: 'Vertė',
 filterPanelInputPlaceholder: 'Filtro vertė',

 // Filter operators text
 filterOperatorContains: 'yra',
 filterOperatorDoesNotContain: 'nėra',
 filterOperatorEquals: 'lygus',
 filterOperatorDoesNotEqual: 'nelygus',
 filterOperatorStartsWith: 'prasideda su',
 filterOperatorEndsWith: 'baigiasi su',
 filterOperatorIs: 'yra',
 filterOperatorNot: 'nėra',
 filterOperatorAfter: 'po',
 filterOperatorOnOrAfter: 'yra po arba lygu',
 filterOperatorBefore: 'prieš',
 filterOperatorOnOrBefore: 'yra prieš arba lygu',
 filterOperatorIsEmpty: 'tuščias',
 filterOperatorIsNotEmpty: 'ne tuščias',
 filterOperatorIsAnyOf: 'yra bet kuris iš',
 'filterOperator=': 'lygu',
 'filterOperator!=': 'nelygu',
 'filterOperator>': 'daugiau nei',
 'filterOperator>=': 'daugiau arba lygu',
 'filterOperator<': 'mažiau nei',
 'filterOperator<=': 'mažiau arba lygu',

 // Header filter operators text
 headerFilterOperatorContains: 'Yra',
 headerFilterOperatorDoesNotContain: 'Nėra',
 headerFilterOperatorEquals: 'Lygu',
 headerFilterOperatorDoesNotEqual: 'Nelygu',
 headerFilterOperatorStartsWith: 'Prasideda su',
 headerFilterOperatorEndsWith: 'Baigiasi su',
 headerFilterOperatorIs: 'Yra',
 headerFilterOperatorNot: 'Nėra',
 headerFilterOperatorAfter: 'Po',
 headerFilterOperatorOnOrAfter: 'Po arba lygu',
 headerFilterOperatorBefore: 'Prieš',
 headerFilterOperatorOnOrBefore: 'Prieš arba lygu',
 headerFilterOperatorIsEmpty: 'Tuščias',
 headerFilterOperatorIsNotEmpty: 'Ne tuščias',
 headerFilterOperatorIsAnyOf: 'Yra bet kuris iš',
 'headerFilterOperator=': 'Lygu',
 'headerFilterOperator!=': 'Nelygu',
 'headerFilterOperator>': 'Daugiau nei',
 'headerFilterOperator>=': 'Daugiau arba lygu',
 'headerFilterOperator<': 'Mažiau nei',
 'headerFilterOperator<=': 'Mažiau arba lygu',
 headerFilterOperator: {
  '=': 'Lygu',
  '!=': 'Nelygu',
  '>': 'Daugiau nei',
  '>=': 'Daugiau arba lygu',
  '<': 'Mažiau nei',
  '<=': 'Mažiau arba lygu',
  contains: 'Yra',
  doesNotContain: 'Nėra',
  startsWith: 'Prasideda su',
  endsWith: 'Baigiasi su',
  is: 'Yra',
  isNot: 'Nėra',
  isAnyOf: 'Yra bet kuris iš',
  equals: 'Lygu',
  doesNotEqual: 'Nelygu',
 }, // do we need it?

 // Filter values text
 filterValueAny: 'bet kuris',
 filterValueTrue: 'tiesa',
 filterValueFalse: 'klaidinga',

 // Column menu text
 columnMenuLabel: 'Meniu',
 columnMenuShowColumns: 'Rodyti stulpelius',
 columnMenuManageColumns: 'Valdyti stulpelius',
 columnMenuFilter: 'Filtruoti',
 columnMenuHideColumn: 'Slėpti stulpelį',
 columnMenuUnsort: 'Atšaukti rūšiavimą',
 columnMenuSortAsc: 'Rūšiuoti pagal ASC',
 columnMenuSortDesc: 'Rūšiuoti pagal DESC',

 //  // Column header text
 //  columnHeaderFiltersTooltipActive: (count: string | number) =>
 //   count !== 1 ? `${count} aktyvūs filtrai` : `${count} aktyvus filtras`,
 //  columnHeaderFiltersLabel: 'Rodyti filtrus',
 //  columnHeaderSortIconLabel: 'Rūšiuoti',

 //  // Rows selected footer text
 //  footerRowSelected: (count: number) =>
 //   count !== 1
 //    ? `${count.toLocaleString()} eilutės pasirinktos`
 //    : `${count.toLocaleString()} eilutė pasirinkta`,

 //  // Total row amount footer text
 //  footerTotalRows: 'Viso eilučių:',

 //  // Total visible row amount footer text
 // //  footerTotalVisibleRows: (
 // //   visibleCount: string | number,
 // //   totalCount: string | number,
 // //  ) => `${visibleCount.toLocaleString()} iš ${totalCount.toLocaleString()}`,

 // Checkbox selection text
 checkboxSelectionHeaderName: 'Pasirinkimas su žymimuoju laukeliu',
 checkboxSelectionSelectAllRows: 'Pasirinkti visas eilutes',
 checkboxSelectionUnselectAllRows: 'Atšaukti visų eilučių pasirinkimą',
 checkboxSelectionSelectRow: 'Pasirinkti eilutę',
 checkboxSelectionUnselectRow: 'Atšaukti eilutės pasirinkimą',

 // Boolean cell text
 booleanCellTrueLabel: 'taip',
 booleanCellFalseLabel: 'ne',

 // Actions cell more text
 actionsCellMore: 'daugiau',

 // Column pinning text
 pinToLeft: 'Prisegti kairėje',
 pinToRight: 'Prisegti dešinėje',
 unpin: 'Atsegti',

 // Tree Data
 treeDataGroupingHeaderName: 'Grupuoti',
 treeDataExpand: 'rodyti vaikus',
 treeDataCollapse: 'slėpti vaikus',

 // Grouping columns
 groupingColumnHeaderName: 'Grupuoti',
 groupColumn: (name: string | number) => `Grupuoti pagal ${name}`,
 unGroupColumn: (name: string | number) => `Nustoti grupuoti pagal ${name}`,

 // Master/detail
 detailPanelToggle: 'Išsami informacija perjungti',
 expandDetailPanel: 'Išplėsti',
 collapseDetailPanel: 'Sutraukti',

 // Used core components translation keys
 MuiTablePagination: {
  labelRowsPerPage: 'Įrašų:',
  labelDisplayedRows: ({
   from,
   to,
   count,
  }: {
   from: number;
   to: number;
   count: number;
  }) => `${from}–${to} iš ${count !== -1 ? count : `daugiau nei ${to}`}`,
 },

 // Row reordering text
 rowReorderingHeaderName: 'Eilučių pertvarkymas',

 // Aggregation
 aggregationMenuItemHeader: 'Agregavimas',
 aggregationFunctionLabelSum: 'suma',
 aggregationFunctionLabelAvg: 'vidurkis',
 aggregationFunctionLabelMin: 'min',
 aggregationFunctionLabelMax: 'maks',
 aggregationFunctionLabelSize: 'dydis',

 headerFilterOperatorModelEqual: 'Lygu',
 headerFilterOperatorModelNotEqual: 'Nelygu',
};
